import { render } from "./NcrmDealsHome.vue?vue&type=template&id=b4b9b282&scoped=true"
import script from "./NcrmDealsHome.vue?vue&type=script&lang=js"
export * from "./NcrmDealsHome.vue?vue&type=script&lang=js"

import "./NcrmDealsHome.vue?vue&type=style&index=0&id=b4b9b282&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b9b282"]])

export default __exports__